import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchLiveUserList,
  fetchViewersList,
  generateAgoraToken,
} from "src/services/live.service";

interface FetchLiveUserListPayload {
  page: number;
  limit: number;
  search?: string;
}

interface FetchViewersListPayload {
  liveId: number;
  page: number;
  limit: number;
}

interface GenerateAgoraTokenPayload {
  channelName?: string;
  role?: "publisher" | "audience";
}

// Fetch live users list
export const doFetchLiveUserList = createAsyncThunk(
  "live/fetchLiveUserList",
  async (payload: FetchLiveUserListPayload) => {
    try {
      const response: any = await fetchLiveUserList({
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch live users list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

// Generate agora token
export const doGenerateAgoraToken = createAsyncThunk(
  "live/generateAgoraToken",
  async (payload: GenerateAgoraTokenPayload) => {
    try {
      const response = await generateAgoraToken(payload);
      return response.data;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to generate Agora token";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doFetchViewersList = createAsyncThunk(
  "live/viewersList",
  async (payload: FetchViewersListPayload) => {
    try {
      const response: any = await fetchViewersList({
        liveId: payload.liveId,
        page: payload.page,
        limit: payload.limit,
      });
      console.log(response);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch viewers list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);
